export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14910.7851d9ad.jpg";